import { render, staticRenderFns } from "./etatsante.vue?vue&type=template&id=354188c2"
import script from "./etatsante.vue?vue&type=script&lang=js"
export * from "./etatsante.vue?vue&type=script&lang=js"
import style0 from "./etatsante.vue?vue&type=style&index=0&id=354188c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports